import i18n from '@/i18n'

const BCP47: Record<string, string> = {
  ko: 'ko-KR',
  en: 'en-US',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  ja: 'ja-JP',
  es: 'es-ES',
  vi: 'vi-VN',
}

/**
 * 현재 UI 언어에 대응하는 BCP47 로케일.
 * 메인 앱의 날짜/숫자 포맷에 사용한다 (어드민은 ko-KR 고정 유지).
 */
export function currentLocale(): string {
  return BCP47[i18n.language] ?? 'ko-KR'
}
